import { render } from "./TipoElem.vue?vue&type=template&id=71c7354f&scoped=true"
import script from "./TipoElem.vue?vue&type=script&lang=js"
export * from "./TipoElem.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=71c7354f&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c7354f"]])

export default __exports__